<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div class="table-toolbar">
      <div class="page-header-section">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="d-flex align-items-center">
              <h5 class="page-title mb-0">{{ 'syncProductsArtist.currentInventory' | transloco }}</h5>
              @if (currentAvailableArtworks > 0) {
                <span class="count-badge ms-2"
                  >
                  {{ currentAvailableArtworks }}
                </span>
              }
            </div>
            <p class="page-subtitle mb-0 mt-1">
              {{ 'syncProductsArtist.searchHint' | transloco }}
            </p>
          </div>
        </div>
      </div>
      <!-- Filters Section -->
      <div class="d-flex justify-content-between align-items-center mt-2 filters-container">
        <div class="form-group me-2 w-100">
          <p-dropdown [options]="artistArtTypes" inputId="artistArtTypes" [filter]="true" [filterBy]="'label'"
            [optionLabel]="'label'" [optionValue]="'value'" name="artistArtTypes" [placeholder]="'syncProductsArtist.filterByArtType' | transloco"
            [(ngModel)]="filters.ArtTypeId" [showClear]="true" (onChange)="onArtTypedChanged($event)">
          </p-dropdown>
        </div>

        <div class="form-group me-2 w-100">
          <p-dropdown [options]="productCategories" inputId="productCategory" name="productCategory" [filter]="true"
            [showClear]="true" [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
            [placeholder]="'syncProductsArtist.filterByCategory' | transloco" [(ngModel)]="filters.ProductCategory" [disabled]="!filters.ArtTypeId"
            (onChange)="onProductCategoriesChange($event)">
          </p-dropdown>
        </div>

        <div class="form-group me-2 w-100">
          <p-dropdown [options]="productSeries" [filter]="true" [showClear]="true" [filterBy]="'label'"
            [optionLabel]="'label'" [optionValue]="'value'" inputId="productSeries" name="productSeries"
            [placeholder]="'syncProductsArtist.filterBySeries' | transloco" [(ngModel)]="filters.ProductSeriesId" [disabled]="!filters.ArtTypeId"
            (onChange)="onProductSeriesChange($event)">
          </p-dropdown>
        </div>

        <div class="form-group me-2 w-100">
          <p-dropdown [options]="galleries" [filter]="true" [showClear]="true" [filterBy]="'label'"
            [optionLabel]="'label'" [optionValue]="'value'" inputId="galleries" name="galleries"
            [placeholder]="'syncProductsArtist.filterByGallery' | transloco" [(ngModel)]="filters.GalleryId" (onChange)="onGalleriesChange($event)">
          </p-dropdown>
        </div>

        <div class="form-group me-2 w-100">
          <p-dropdown [options]="statusFilterOptions" [filter]="true" [showClear]="true" inputId="statusFilter"
            name="statusFilter" [placeholder]="'syncProductsArtist.filterByStatus' | transloco" [(ngModel)]="filters.Status"
          (onChange)="onStatusFilterChange($event)"></p-dropdown>
        </div>
        <div class="form-group me-2 w-100">
          <input type="text" class="form-control" [placeholder]="'syncProductsArtist.filterItems' | transloco" [(ngModel)]="filters.Query"
            (input)="onGlobalFilterProduct($event)" />
          </div>
          <div class="form-group me-2 w-100">
            <p-button type="button" icon="pi pi-times" iconPos="left" [outlined]="true" severity="secondary"
            (click)="clearAllFilters($event)" class="p-button-sm" [label]="'syncProductsArtist.clearAll' | transloco"></p-button>
          </div>
        </div>

        <div class="row mt-2 p-2">
          <div class="col-9 border px-3 py-3 bg-white shadow-sm">
            <div class="row">
              <div class="d-flex justify-content-between align-items-center mb-2 px-2">
                <div class="fw-bold fs-6">
                  <i class="pi pi-images color-artwork me-1"></i> {{ 'syncProductsArtist.artistArtworks' | transloco }}
                </div>
              </div>

              <div class="text-muted small px-2 mb-3">
                {{ 'syncProductsArtist.artistArtworksDescription' | transloco }}
              </div>
              <!-- <div class="col-2 mb-3" *ngFor="let product of artistProducts">
              <div class="position-relative">
                <div
                  class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-light h-100 cursor-pointer product-background border"
                  (click)="selectInventory(product)" style="transition: transform 0.2s;">

                  <div class="image-container d-flex justify-content-center align-items-center p-2 border-bottom w-100">
                    <img [src]="product.ResizedImageUrl ? product.ResizedImageUrl : 'assets/images/No-Image.png'"
                      alt="{{ product.Name }}" class="img-fluid rounded"
                      style="max-height: 100px; object-fit: contain;" />
                    </div>

                    <div class="text-center px-2 py-2 w-100">
                      <h3 class="card-title text-uppercase text-truncate small mb-0">
                        {{ product.Name }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div> -->

              @for (product of artistProducts; track product) {
                <div class="col-2 mb-3">
                  <div class="d-flex flex-column align-items-center rounded-3 shadow bg-light border h-100 cursor-pointer"
                    (click)="selectInventory(product); $event.stopPropagation()"
                    style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.03)';"
                    onmouseout="this.style.transform='scale(1)';"
                    [title]="'syncProductsArtist.clickToRemove' | transloco: { name: product.Name }">
                    <div class="image-container d-flex justify-content-center align-items-center p-1 border-bottom w-100 position-relative"
                      [title]="'syncProductsArtist.clickToViewDetails' | transloco: { name: product.Name }">
                      <!-- Circle Icon Top Right -->
                      <div class="position-absolute top-0 end-0 m-2  "
                        (click)="openProductDialog(product.Id); $event.stopPropagation()">
                        <i class="fa fa-info-circle fs-4 "></i>
                      </div>
                      <img [src]="product.ResizedImageUrl ? product.ResizedImageUrl : 'assets/images/No-Image.png'"
                        class="img-fluid rounded object-fit: contain; w-100" />
                      </div>
                      <div class="text-center px-2 py-2 w-100">
                        <div class="text-uppercase fw-semibold text-dark text-truncate small">
                          {{ product.Name }}
                        </div>
                      </div>
                    </div>
                  </div>
                }

                @if (artistProducts.length === 0) {
                  <div class="d-flex justify-content-center text-muted py-5">
                    <i class="pi pi-image me-2"></i>
                    @if (loadingArtistProducts) {
                      {{ 'syncProductsArtist.loadingYourProducts' | transloco }}
                    }
                    @if (!loadingArtistProducts) {
                      {{ 'syncProductsArtist.noAvailableArtworks' | transloco }}
                    }
                  </div>
                }
              </div>
            </div>

            <div class="col-3 border py-3 bg-light shadow-sm">
              <div class="row">
                <div class="d-flex flex-column mb-3 px-2">
                  <div class="fw-bold fs-6 text-center">
                    {{ 'syncProductsArtist.selectedArtworks' | transloco }}
                  </div>

                  @if (selectedGalleryProductsInventory.length > 0) {
                    <div class="text-muted small text-center px-2 mb-3">
                      {{ 'syncProductsArtist.selectedArtworksDescription' | transloco }}
                    </div>
                  }
                  <div class="d-flex justify-content-center mb-2">
                    @if (selectedGalleryProductsInventory.length > 0) {
                      <span
                        class="badge text-white d-inline-flex align-items-center justify-content-center"
                        style="background-color: #178d9b; font-weight: 700; width: 30px; height: 30px; border-radius: 50%;">
                        {{ selectedGalleryProductsInventory.length }}
                      </span>
                    }
                  </div>

                  @if (selectedGalleryProductsInventory.length > 0) {
                    <div class="d-flex justify-content-center mt-3 mb-3">
                      <button pButton type="button" [label]="'syncProductsArtist.syncProducts' | transloco" icon="pi pi-sync"
                      class="p-button-outlined p-button-sm text-success" (click)="onSyncArtworksClick()"></button>
                    </div>
                  }

                  @if (selectedGalleryProductsInventory.length > 0) {
                    <div class="text-muted text-center small mb-3">
                      {{ 'syncProductsArtist.syncProductsHint' | transloco }}
                    </div>
                  }
                </div>

                @if (selectedGalleryProductsInventory.length === 0) {
                  <div
                    class="d-flex justify-content-center text-muted py-4">
                    <i class="pi pi-info-circle me-1 mt-1"></i>
                    {{ 'syncProductsArtist.noProductsSelected' | transloco }}
                  </div>
                }


                @for (product of selectedGalleryProductsInventory; track product; let i = $index) {
                  <div class="col-6 mb-3 drag-item">
                    <div class="d-flex flex-column align-items-center rounded-3 shadow bg-light border h-100 cursor-pointer"
                      (click)="moveToCurrentInventory(product); $event.stopPropagation()"
                      style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.03)';"
                      onmouseout="this.style.transform='scale(1)';"
                      title="Click to remove '{{ product.Name }}' from consignment">
                      <div class="image-container d-flex justify-content-center align-items-center p-1 border-bottom w-100 position-relative"
                        title="Click to view details of '{{ product.Name }}'">
                        <!-- Circle Icon Top Right -->
                        <div class="position-absolute top-0 end-0 m-2  "
                          (click)="openProductDialog(product.Id); $event.stopPropagation()">
                          <i class="fa fa-info-circle fs-4 "></i>
                        </div>
                        <img [src]="product.ProductImgUrl || 'assets/images/No-Image.png'"
                          class="img-fluid rounded object-fit: contain; w-100" />
                        </div>
                        <div class="text-center px-2 py-2 w-100">
                          <div class="text-uppercase fw-semibold text-dark text-truncate small">
                            {{ product.Name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  }


                  <!-- <div class="col-6 mb-3 drag-item" *ngFor="let product of selectedGalleryProductsInventory; let i = index">
                  <div
                    class="border rounded shadow-sm d-flex flex-column align-items-center bg-white h-100 cursor-pointer selected-inventry-product product-background"
                    (click)="moveToCurrentInventory(product)">

                    <div class="image-container d-flex justify-content-center align-items-center w-100 p-2 border-bottom">
                      <img [src]="product.ProductImgUrl ? product.ProductImgUrl : 'assets/images/No-Image.png'"
                        alt="{{ product.Name }}" class="img-fluid rounded"
                        style="max-height: 100px; object-fit: contain;" />
                      </div>

                      <div class="text-center p-2 w-100">
                        <div class="small text-uppercase text-truncate fw-semibold">
                          {{ product.Name }}
                        </div>
                      </div>
                    </div>
                  </div> -->




                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <p-dialog [header]="'syncProductsArtist.syncToOnlineStores' | transloco" [(visible)]="selectedPlatformDailaog" [modal]="true"
        [style]="{ width: '750px' }" (onHide)="resetPlatformDialog()">
        <div class="p-4 mb-3">
          <p class="text-muted mb-4">
            {{ 'syncProductsArtist.selectStoresDescription' | transloco }}
          </p>

          <!-- WooCommerce Section -->
          @if (!isWoocommerce && wooCommerceAccountList.length > 0) {
            <div class="mb-4 p-3 border-round"
              style="background-color: #f8f9fa;">
              <div class="d-flex align-items-center mb-2">
                <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" class="me-2"
                  style="width: 30px; height: 30px;" />
                  <h5 class="m-0">{{ 'syncProductsArtist.woocommerceStores' | transloco }}</h5>
                  <span class="badge bg-secondary ms-2">{{ 'syncProductsArtist.connected' | transloco: { count: wooCommerceAccountList.length } }}</span>
                </div>
                <p class="small text-muted mb-2">
                  <i class="pi pi-info-circle"></i> {{ 'syncProductsArtist.woocommerceStoreHint' | transloco }}
                </p>
                <div class="store-list">
                  <!-- None option -->
                  <div class="mb-2 p-2 border-round" style="background-color: white;">
                    <p-radioButton name="wooRadio" [value]="''" [(ngModel)]="selectedWoocommerceStore"
                      (onClick)="toggleRadio('woocommerce', '')" [label]="'syncProductsArtist.none' | transloco">
                    </p-radioButton>
                  </div>
                  <!-- Store options -->
                  @for (store of wooCommerceAccountList; track store) {
                    <div class="mb-2 p-2 border-round"
                      style="background-color: white;">
                      <p-radioButton name="wooRadio" [value]="store.Id" [(ngModel)]="selectedWoocommerceStore"
                        (onClick)="toggleRadio('woocommerce', store.Id)" [label]="store.StoreName">
                      </p-radioButton>
                    </div>
                  }
                </div>
                @if (selectedWoocommerceStore && selectedWoocommerceStore !== '') {
                  <p class="small text-success mt-2">
                    <i class="pi pi-check-circle"></i> {{ 'syncProductsArtist.willSyncToWoocommerce' | transloco }}
                  </p>
                }
              </div>
            }

            <!-- Shopify Section -->
            @if (!isShopify && ShopifyStoreAccountList.length > 0) {
              <div class="mb-4 p-3 border-round"
                style="background-color: #f8f9fa;">
                <div class="d-flex align-items-center mb-2">
                  <img src="assets/images/shopify-log.png" alt="Shopify Logo" class="me-2" style="width: 30px; height: 30px;" />
                  <h5 class="m-0">{{ 'syncProductsArtist.shopifyStores' | transloco }}</h5>
                  <span class="badge bg-secondary ms-2">{{ 'syncProductsArtist.connected' | transloco: { count: ShopifyStoreAccountList.length } }}</span>
                </div>
                <p class="small text-muted mb-2">
                  <i class="pi pi-info-circle"></i> {{ 'syncProductsArtist.shopifyStoreHint' | transloco }}
                </p>
                <div class="store-list">
                  <!-- None option -->
                  <div class="mb-2 p-2 border-round" style="background-color: white;">
                    <p-radioButton name="shopifyRadio" [value]="''" [(ngModel)]="selectedShopifyStore"
                      (onClick)="toggleRadio('shopify', '')" [label]="'syncProductsArtist.none' | transloco">
                    </p-radioButton>
                  </div>
                  <!-- Store options -->
                  @for (store of ShopifyStoreAccountList; track store) {
                    <div class="mb-2 p-2 border-round"
                      style="background-color: white;">
                      <p-radioButton name="shopifyRadio" [value]="store.Id" [(ngModel)]="selectedShopifyStore"
                        (onClick)="toggleRadio('shopify', store.Id)" [label]="store.StoreName">
                      </p-radioButton>
                    </div>
                  }
                </div>
                @if (selectedShopifyStore && selectedShopifyStore !== '') {
                  <p class="small text-success mt-2">
                    <i class="pi pi-check-circle"></i> {{ 'syncProductsArtist.willSyncToShopify' | transloco }}
                  </p>
                }
              </div>
            }

            <!-- Square Space Section -->
            @if (isSquareSpaceAccountExists) {
              <div class="mb-4 p-3 border-round" style="background-color: #f8f9fa;">
                <div class="d-flex align-items-center mb-2">
                  <img src="assets/images/squarespace.svg" alt="SquareSpace Logo" class="me-2"
                    style="width: 30px; height: 30px;" />
                    <h5 class="m-0">SquareSpace</h5>
                  </div>
                  <p class="small text-muted mb-2">
                    <i class="pi pi-info-circle"></i> {{ 'syncProductsArtist.squareSpaceHint' | transloco }}
                  </p>
                  <div class="mb-3">
                    <!-- None option -->
                    <div class="mb-3 p-2 border-round" style="background-color: white;">
                      <p-radioButton [name]="'squareSpaceSite'" [value]="''" [(ngModel)]="squareSpaceSiteId"
                        (onClick)="toggleRadio('squarespace', '')" [label]="'syncProductsArtist.none' | transloco">
                      </p-radioButton>
                    </div>
                    <!-- Site options -->
                    @for (store of squareSpaceSiteDetails; track store) {
                      <div class="mb-3">
                        <div class="p-2 border-round" style="background-color: white;">
                          <p-radioButton [name]="'squareSpaceSite'" [value]="store.Id" [(ngModel)]="squareSpaceSiteId"
                            (onClick)="onSquareSpaceSelected(store.Id)" [label]="store.SiteInfo.title">
                          </p-radioButton>
                        </div>
                        <!-- Page selection dropdown - shown only when this store is selected -->
                        @if (squareSpaceSiteId === store.Id) {
                          <div class="mt-2 ml-4 pl-3" style="border-left: 2px solid #dee2e6;">
                            <label class="form-label">{{ 'syncProductsArtist.selectShopPage' | transloco }}</label>
                            <p-dropdown [options]="squareSpaceSitePageDetails" optionLabel="title" optionValue="id"
                              [(ngModel)]="squareSpacePageId" [placeholder]="'syncProductsArtist.selectAPage' | transloco" (onChange)="onChangeSquareSpacePage($event)"
                              [style]="{width: '100%'}" [disabled]="!squareSpaceSitePageDetails.length">
                              <ng-template pTemplate="empty">
                                <div class="text-muted small">
                                  @if (loadingSquareSpacePages) {
                                    <span>{{ 'syncProductsArtist.loadingPages' | transloco }}</span>
                                  }
                                  @if (!loadingSquareSpacePages) {
                                    <span>{{ 'syncProductsArtist.noPagesAvailable' | transloco }}</span>
                                  }
                                </div>
                              </ng-template>
                            </p-dropdown>
                            <small class="text-muted d-block mt-1">
                              <i class="pi pi-info-circle"></i> {{ 'syncProductsArtist.typicallySelectShopPage' | transloco }}
                            </small>
                            @if (squareSpacePageId) {
                              <p class="small text-success mt-2">
                                <i class="pi pi-check-circle"></i> {{ 'syncProductsArtist.willSyncToSquareSpace' | transloco }}
                              </p>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              <!-- Sync Now Button -->
              @if (wooCommerceAccount || shopifyAccount || isSquareSpaceAccountExists) {
                <div class="text-center mt-4">
                  @if (!hasSelectedStore()) {
                    <div class="alert alert-info mb-3">
                      <i class="pi pi-info-circle"></i> {{ 'syncProductsArtist.selectAtLeastOneStore' | transloco }}
                    </div>
                  }
                  <p-button [disabled]="!canSync()" [label]="'syncProductsArtist.syncNow' | transloco" icon="pi pi-sync" class="p-button-success"
                    (click)="onSyncNowClick()">
                  </p-button>
                  <p class="small text-muted mt-2">
                    <i class="pi pi-clock"></i> {{ 'syncProductsArtist.syncingMayTakeTime' | transloco }}
                  </p>
                </div>
              }

              <!-- No Stores Connected (full warning when nothing connected) -->
              @if (!wooCommerceAccount && !shopifyAccount && !isSquareSpaceAccountExists) {
                <div
                  class="text-center p-4 border-round mb-4" style="background-color: #fff8f8; border: 1px dashed #ffcccc;">
                  <div class="mb-4">
                    <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #ff6b6b;"></i>
                    <h4 class="mt-2" style="color: #d32f2f;">{{ 'syncProductsArtist.noStoresConnected' | transloco }}</h4>
                    <p class="text-muted">
                      {{ 'syncProductsArtist.noStoresConnectedDescription' | transloco }}
                    </p>
                  </div>
                  <!-- Your original button layout with danger styling -->
                  <div class="text-center mt-4 pt-3">
                    @if (!wooCommerceAccount) {
                      <p-button [label]="'syncProductsArtist.connectWoocommerce' | transloco" icon="pi pi-plus"
                        styleClass="p-button-danger p-button-outlined me-2" (onClick)="onShowWoocommerceAccountDailog()">
                      </p-button>
                    }
                    @if (!shopifyAccount) {
                      <p-button [label]="'syncProductsArtist.connectShopify' | transloco" icon="pi pi-plus"
                        styleClass="p-button-danger p-button-outlined me-2" (onClick)="onShowShopifyAccountDialog()">
                      </p-button>
                    }
                    @if (!isSquareSpaceAccountExists) {
                      <p-button [label]="'syncProductsArtist.connectSquareSpace' | transloco" icon="pi pi-plus"
                        styleClass="p-button-danger p-button-outlined" (onClick)="onConnectSquareSpaceAccount()">
                      </p-button>
                    }
                  </div>
                  <p class="small text-muted mt-3">
                    <i class="pi pi-info-circle"></i> {{ 'syncProductsArtist.refreshAfterConnecting' | transloco }}
                  </p>
                </div>
              }

              <!-- Normal mode (when at least one store is connected) -->
              @if (wooCommerceAccount || shopifyAccount || isSquareSpaceAccountExists) {
                <div>
                  <!-- Original button layout for remaining unconnected accounts -->
                  <div class="text-center mt-4 pt-3 border-top">
                    @if (!wooCommerceAccount) {
                      <p-button [label]="'syncProductsArtist.connectWoocommerce' | transloco" icon="pi pi-plus"
                        styleClass="p-button-outlined me-2 p-button-danger" (onClick)="onShowWoocommerceAccountDailog()">
                      </p-button>
                    }
                    @if (!shopifyAccount) {
                      <p-button [label]="'syncProductsArtist.connectShopify' | transloco" icon="pi pi-plus"
                        styleClass="p-button-outlined me-2 p-button-danger" (onClick)="onShowShopifyAccountDialog()">
                      </p-button>
                    }
                    @if (!isSquareSpaceAccountExists) {
                      <p-button [label]="'syncProductsArtist.connectSquareSpace' | transloco" icon="pi pi-plus"
                        styleClass="p-button-outlined p-button-danger" (onClick)="onConnectSquareSpaceAccount()">
                      </p-button>
                    }
                  </div>
                </div>
              }
            </div>
          </p-dialog>


          <p-dialog [(visible)]="displayCurrencyDialog" [modal]="true" [closable]="true" [header]="'syncProductsArtist.platformCurrencySettings' | transloco"
            [style]="{ width: '650px' }">

            <div class="mb-2">
              <!-- <p-dropdown id="storeDropdown" [options]="StoreDetail" optionLabel="StoreName" optionValue="Id"
              placeholder="Select WooCommerce Store" (onChange)="onWoocommerceStoreChange($event)">
            </p-dropdown> -->
          </div>
          <!-- Loading State -->
          @if (isLoading ) {
            <div class="d-flex justify-content-center align-items-center flex-column"
              style="min-height: 200px;">
              <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
              <p class="mt-3 text-muted" style="font-size: 1.2rem; font-weight: normal;">{{ 'syncProductsArtist.loadingExchangeRates' | transloco }}</p>
            </div>
          }

          <!-- Dialog Content (Visible After Loading) -->
          @if (!isLoading) {
            <div class="dialog-content p-2">
              <!-- Information Section -->
              <div class="mb-4">
                <p class="text-muted mb-2" style="font-size: 1.1rem; line-height: 1.5; font-weight: normal;">
                  {{ 'syncProductsArtist.defaultPricingCurrency' | transloco }}
                  @if (platforms?.BasePlateform) {
                    {{ platforms.BasePlateform }} {{ 'syncProductsArtist.inArtflowPortal' | transloco }}
                  }
                </p>
                <p class="text-muted" style="font-size: 1.1rem; line-height: 1.5; font-weight: normal;">
                  {{ 'syncProductsArtist.exchangeRatesFetchedFrom' | transloco }}
                  <strong><a href="https://openexchangerates.org/" target="_blank">openexchangerates.org</a></strong>
                  {{ 'syncProductsArtist.orEnteredManually' | transloco }}
                </p>
              </div>
              <!-- Info Alert -->
              <div class="alert alert-info mb-4" style="font-size: 1rem; border-left: 4px solid #17a2b8; padding: 0.75rem;">
                <strong>{{ 'syncProductsArtist.note' | transloco }}</strong> {{ 'syncProductsArtist.currencyNoteDescription' | transloco }}
              </div>
              <!-- Exchange Rates Table -->
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th>{{ 'syncProductsArtist.platform' | transloco }}</th>
                      <th>{{ 'syncProductsArtist.currency' | transloco }}</th>
                      <th>{{ 'syncProductsArtist.exchangeRate' | transloco }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (platform of platforms?.IntegratedPlateformCurrencyExchangeRate; track platform) {
                      <tr>
                        @if (platform.ResponseObject.Success && !platform.IsPlateformCurrencyIsDifferent) {
                          <td>{{ platform.Plateform }}</td>
                          <td colspan="2" class="text-danger">
                            {{ platform.ResponseObject.ResponseMessage }}
                          </td>
                        }
                        @if (platform.ResponseObject.Success && platform.IsPlateformCurrencyIsDifferent) {
                          <td>{{ platform.Plateform }}</td>
                          <td>{{ platform.TargetCurrencySymbol }}</td>
                          <td>{{ platform.ExchangeRate | number: '1.2-2' }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          <!-- Footer Actions -->
          <ng-template pTemplate="footer">
            <div class="d-flex justify-content-end p-2">
              <!-- Button: Continue without Rate (Secondary) -->
              <p-button [label]="'syncProductsArtist.continueWithoutRate' | transloco" [outlined]="true" severity="secondary" [disabled]="isLoading"
                (onClick)="acceptConsignmentProducts($event)">
              </p-button>

              <!-- Button: Continue with Rate (Success) -->
              <p-button type="button" [outlined]="true" severity="success" class="p-button-sm ms-2" [label]="'syncProductsArtist.continueWithRate' | transloco"
                [disabled]="isLoading" (onClick)="acceptConsignmentProducts($event)">
              </p-button>
            </div>
          </ng-template>

        </p-dialog>


        @if (isStripeDisplayPlansDialogVisible) {
          <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
            [stripeAllPlans]="stripePlans" (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)">
          </stripe-payment-plan>
        }

        @if (isAddWoocommerceAccountDailogVisible) {
          <shopify-and-woocommerce-dailog [platform]="'woocommerce'"
            [isAddPlatformAccountDailogVisible]="isAddWoocommerceAccountDailogVisible"
            (onClosePlatformCredentialDailog)="onCloseWoocommerceAccountDailog($event)">
          </shopify-and-woocommerce-dailog>
        }

        @if (isShopifyConnectionDailogVisible) {
          <shopify-and-woocommerce-dailog [platform]="'shopify'"
            [isAddPlatformAccountDailogVisible]="isShopifyConnectionDailogVisible"
          (onClosePlatformCredentialDailog)="onCloseShopifyConnectionDailog($event)"></shopify-and-woocommerce-dailog>
        }

        <p-dialog [header]="'syncProductsArtist.syncSummary' | transloco" [(visible)]="showSyncResultsDialog" [modal]="true" [closable]="true"
          [style]="{ width: '870px' }">

          <div class="sync-results-container">

            <!-- Big Status Message -->
            <div class="overall-status"
              [ngClass]="{'success': syncResults.overallSuccess, 'error': !syncResults.overallSuccess}">
              <i class="pi" [ngClass]="syncResults.overallSuccess ? 'pi-check-circle' : 'pi-exclamation-circle'"></i>
              <div class="status-text">
                <h3>{{ (syncResults.overallSuccess ? 'syncProductsArtist.syncComplete' : 'syncProductsArtist.syncCompletedWithIssues') | transloco }}</h3>
                <p>{{ syncResults.overallMessage ||
                ((syncResults.overallSuccess ? 'syncProductsArtist.allItemsProcessed' : 'syncProductsArtist.someItemsNeedAttention') | transloco) }}</p>
              </div>
            </div>

            <!-- Platform Results -->
            <div class="platform-results">
              @for (platform of syncResults.platforms; track platform) {
<div class="platform-result" [ngClass]="{
        'success': platform.success,
        'warning': platform.hasWarnings,
        'error': !platform.success && !platform.hasWarnings
      }">
                  <div class="platform-header">
          <i class="pi" [ngClass]="{
            'pi-check-circle success-icon': platform.success,
            'pi-exclamation-triangle warning-icon': platform.hasWarnings,
            'pi-times-circle error-icon': !platform.success && !platform.hasWarnings
          }"></i>
                    <h3>{{platform.name}}</h3>
          <span class="status-badge" [ngClass]="{
            'success-badge': platform.success,
            'warning-badge': platform.hasWarnings,
            'error-badge': !platform.success && !platform.hasWarnings
          }">
                      {{ (platform.success ? 'syncProductsArtist.done' : platform.hasWarnings ? 'syncProductsArtist.partial' : 'syncProductsArtist.failed') | transloco }}
                    </span>
                  </div>
                  <div class="platform-details">
                    <p class="sync-status-message">
                      @if (platform.success) {
                        {{ 'syncProductsArtist.allItemsProcessed' | transloco }}
                      }
                      @if (platform.hasWarnings) {
                        {{ 'syncProductsArtist.completedWithWarnings' | transloco }}
                      }
                      @if (!platform.success && !platform.hasWarnings) {
                        {{ 'syncProductsArtist.couldNotCompleteSync' | transloco }}
                      }
                    </p>
                    <div class="counters">
                      @if (platform.newSyncedCount > 0) {
                        <span class="counter new">
                          {{ 'syncProductsArtist.newProductsPushed' | transloco: { count: platform.newSyncedCount } }}
                        </span>
                      }
                      @if (platform.existingSyncedCount > 0) {
                        <span class="counter existing">
                          {{ 'syncProductsArtist.existingProductsUpdated' | transloco: { count: platform.existingSyncedCount } }}
                        </span>
                      }
                    </div>
                    @if (platform.message) {
                      <p class="platform-message">
                        <i class="pi pi-info-circle"></i> {{platform.message}}
                      </p>
                    }
                  </div>
                </div>
              }
            </div>

            <!-- Help Section -->
            <div class="help-tip">
              <i class="pi pi-info-circle"></i>
              <div>
                <p><strong>{{ 'syncProductsArtist.whatStatusesMean' | transloco }}</strong></p>
                <p>• <strong>{{ 'syncProductsArtist.newProductsPushedLabel' | transloco }}</strong> - {{ 'syncProductsArtist.newProductsPushedHelp' | transloco }}</p>
                <p>• <strong>{{ 'syncProductsArtist.existingProductsUpdatedLabel' | transloco }}</strong> - {{ 'syncProductsArtist.existingProductsUpdatedHelp' | transloco }}</p>
              </div>
            </div>
          </div>

          <ng-template pTemplate="footer">
            <button pButton type="button" [label]="'syncProductsArtist.close' | transloco" (click)="showSyncResultsDialog=false" class="close-button"></button>
          </ng-template>
        </p-dialog>


        @if (showProductDialog) {
          <app-product-details-dialog [showProductDialog]="showProductDialog" [productId]="productId"
            (onClose)="closeProductDialog()">
          </app-product-details-dialog>
        }